// extracted by mini-css-extract-plugin
export default {"container":"DetailLayout_container__bJztB","tips":"DetailLayout_tips__FdUQZ"};